import { useQuery } from '@apollo/react-hooks';
import { useRouter } from 'next/compat/router';

import { useExternalUserDetails } from './hooks/use-external-user-details';
import getCheckout from './get-checkout.gql';

export default function useCartDataFromServer(dispensary) {
  const router = useRouter();
  const { checkoutId, dispensaryId } = router?.query ?? {};

  const { data, error } = useQuery(getCheckout, {
    skip: !checkoutId || !dispensaryId,
    variables: { checkoutId, dispensaryId },
  });

  useExternalUserDetails();

  if (error) {
    const plusDefaultReturnUrl = dispensary?.plusSettings?.defaultReturnUrl;

    if (!plusDefaultReturnUrl) {
      console.error(`No return url found`);
    } else {
      const redirectUrl = `${plusDefaultReturnUrl}?checkoutError=NOT_FOUND`;
      window.location.href = redirectUrl;
      return null;
    }
  }

  return data?.getCheckout;
}
